export default "__VITE_ASSET__Bw8lXeFK__"